// This file orchestrates the rendering of all artistic modes
// Individual mode implementations are in the ./modes/ folder

import React from "react";
import {
  GrandmaMode,
  ConvexMode,
  ConcaveMode,
  CheckerMode,
  SpiralMode,
  MoireMode,
  DiamondMode,
  IsoMode,
  ShieldMode,
  ShieldHoneyMode,
  LockMode,
  RadarMode,
  MeshMode,
  CircuitMode,
  CodeRainMode,
  FingerprintMode,
  FirewallMode,
  AgamBarsMode,
  AgamogramMode,
  AgamPrismMode,
  AgamWeaveMode,
  CalderHoweMode,
  TinguelyJansenMode,
  TinguelyMode,
  TinguelyGearsMode,
  TinguelyWheelsMode,
  JansenMode,
  JansenLegsMode,
  JansenWindMode,
  VasarelyMondrianMode,
  VasarelyLeCorbusierMode,
  VasarelyBauhausMode,
  VasarelyKandinskyMode,
  VasarelyEamesMode,
  VasarelyMiesMode,
  VasarelyFosterMode,
  VasarelySolLewittMode,
  VasarelyMolnarMode,
  VasarelyCaseyReasMode,
  VasarelyAnadolMode,
  VasarelyMohrMode,
  VasarelyAlbersMode,
  VasarelyRileyMode,
  VasarelyEscherMode,
  VasarelyTurrellMode,
  VasarelyCalderMode,
  VasarelyHoweMode,
  VasarelyAgamMode,
  VasarelyTuringMode,
  VasarelySuzanMode,
  VasarelyDaVinciMode,
  VasarelyMichelangeloMode,
  VasarelyRaphaelMode,
  VasarelyVelazquezMode,
  VasarelyIngresMode,
  VasarelyCaravaggioMode,
  VasarelyRembrandtMode,
  VasarelyVermeerMode,
  VasarelyGoyaMode,
  VasarelyCourbetMode,
  VasarelyTurnerMode,
  VasarelyDelacroixMode,
  VasarelyMonetMode,
  VasarelyVanGoghMode,
  VasarelyDegasMode,
  VasarelyCezanneMode,
  VasarelySeuratMode,
  VasarelyMatisseMode,
  VasarelyPicassoMode,
  VasarelyDaliMode,
  VasarelyHermesMode,
  VasarelyChanelMode,
  VasarelyDiorMode,
  VasarelyLouisVuittonMode,
  VasarelyCartierMode,
  VasarelyVancleefMode,
  VasarelyRolexMode,
  VasarelyPradaMode,
  VasarelyGivenchyMode,
  VasarelyYslMode,
  VasarelyBalenciagaMode,
  VasarelyMargielaMode,
  VasarelyIsseyMode,
  VasarelyTeslaMode,
  VasarelyAppleMode,
  VasarelyTagheuerMode,
  VasarelyMontblancMode,
  VasarelyRimowaMode,
  VasarelyRichardmilleMode,
  VasarelyRollsroyceMode,
  VasarelyBoMode,
  VasarelyLeicaMode,
  VasarelyBottegaMode,
  VasarelyMonclerMode,
  VasarelySuzanLuxuryMode,
  VasarelyAirbusMode,
  VasarelySafranMode,
  VasarelyDassaultsystemesMode,
  VasarelyThalesMode,
  VasarelyCapgeminiMode,
  VasarelyAtosMode,
  VasarelyOrangeMode,
  VasarelyBouyguesMode,
  VasarelyVinciMode,
  VasarelyTotalenergiesMode,
  VasarelyEngieMode,
  VasarelyEdfMode,
  VasarelyLvmhMode,
  VasarelyLorealMode,
  VasarelySanofiMode,
  VasarelyDanoneMode,
  VasarelyVeoliaMode,
  VasarelyBnpMode,
  VasarelySocgenMode,
  VasarelyAxaMode,
  VasarelyCreditagricoleMode,
  VasarelyVivendiMode,
  VasarelyPublicisMode,
  VasarelyRenaultMode,
  VasarelyStellantisMode,
  VasarelyMichelinMode,
  VasarelyAirliquideMode,
  VasarelyKeringMode,
  VasarelySuzanaiMode,
  VasarelyCernMode,
  VasarelyDwaveMode,
  VasarelyNasajplMode,
  VasarelyGpt5Mode,
  VasarelyDeepmindMode,
  VasarelyOpenaisafetyMode,
  VasarelyIpccMode,
  VasarelyOceancleanupMode,
  VasarelyEsagaiaMode,
  VasarelyCrisprMode,
  VasarelyHppMode,
  VasarelyPasteurMode,
  VasarelyBrianenoMode,
  VasarelyNeuralinkMode,
  VasarelyIrcamMode,
  VasarelyUnescoaiethicsMode,
  VasarelyWorldbankMode,
  VasarelyBlockchaingovernanceMode,
  VasarelyWhoMode,
  VasarelyUnicefMode,
  VasarelyApcMode,
  VasarelyKitsuneMode,
  VasarelyAmiMode,
  VasarelyJacquemusMode,
  VasarelySezaneMode,
  VasarelyLelaboMode,
  VasarelyLemaireMode,
  VasarelyEtudesMode,
  VasarelySandroMode,
  VasarelyClaudieMode,
  VasarelyBonparfumeurMode,
  VasarelyMerciMode,
  VasarelyLouvreposterclubMode,
  VasarelyBulyMode,
  VasarelyPaperclubMode,
  VasarelyAlainmikliMode,
  VasarelyPapiertigreMode,
  VasarelyAstierMode,
  VasarelyFragonardMode,
  VasarelySuzanaiBoboMode,
  VasarelyGirafeMode
} from "./modes";
import {
  VasarelyLionMode,
  VasarelyTigerMode,
  VasarelyElephantMode,
  VasarelyZebraMode,
  VasarelyLeopardMode,
  VasarelyCheetahMode,
  VasarelyGazelleMode,
  VasarelyRhinoMode,
  VasarelyHippoMode,
  VasarelyPenguinMode,
  VasarelyOwlMode,
  VasarelyEagleMode,
  VasarelyFoxMode,
  VasarelyWolfMode,
  VasarelyBearMode,
  VasarelyKangarooMode,
  VasarelyKoalaMode,
  VasarelyFlamingoMode,
  VasarelyWhaleMode,
  VasarelyDolphinMode,
} from "./modes";
import { VasarelyCapybaraMode } from "./modes";

interface SVGModeRendererProps {
  mode: string;
  brand: any;
  Copy: any;
}

export function SVGModeRenderer({ mode, brand, Copy }: SVGModeRendererProps) {
  // date/version were removed from Copy; many mode files still accept a `today` prop
  // to stay compatible we pass an empty string as a placeholder. Modes should not
  // render the date/version anymore.
  const today = "";
  const props = { brand, today, Copy } as any;

  switch (mode) {
    case "grandma":
      return <GrandmaMode {...props} />;
    case "convex":
      return <ConvexMode {...props} />;
    case "concave":
      return <ConcaveMode {...props} />;
    case "checker":
      return <CheckerMode {...props} />;
    case "spiral":
      return <SpiralMode {...props} />;
    case "moire":
      return <MoireMode {...props} />;
    case "diamond":
      return <DiamondMode {...props} />;
    case "iso":
      return <IsoMode {...props} />;
    case "shield":
      return <ShieldMode {...props} />;
    case "shieldHoney":
      return <ShieldHoneyMode {...props} />;
    case "lock":
      return <LockMode {...props} />;
    case "radar":
      return <RadarMode {...props} />;
    case "mesh":
      return <MeshMode {...props} />;
    case "circuit":
      return <CircuitMode {...props} />;
    case "codeRain":
      return <CodeRainMode {...props} />;
    case "fingerprint":
      return <FingerprintMode {...props} />;
    case "firewall":
      return <FirewallMode {...props} />;
    case "agamBars":
      return <AgamBarsMode {...props} />;
    case "agamogram":
      return <AgamogramMode {...props} />;
    case "agamPrism":
      return <AgamPrismMode {...props} />;
    case "agamWeave":
      return <AgamWeaveMode {...props} />;
    case "calderHowe":
      return <CalderHoweMode {...props} />;
    case "tinguelyJansen":
      return <TinguelyJansenMode {...props} />;
    case "tinguely":
      return <TinguelyMode {...props} />;
    case "tinguelyGears":
      return <TinguelyGearsMode {...props} />;
    case "tinguelyWheels":
      return <TinguelyWheelsMode {...props} />;
    case "jansen":
      return <JansenMode {...props} />;
    case "jansenLegs":
      return <JansenLegsMode {...props} />;
    case "jansenWind":
      return <JansenWindMode {...props} />;
    case "vasarelyMondrian":
      return <VasarelyMondrianMode {...props} />;
    case "vasarelyLeCorbusier":
      return <VasarelyLeCorbusierMode {...props} />;
    case "vasarelyBauhaus":
      return <VasarelyBauhausMode {...props} />;
    case "vasarelyKandinsky":
      return <VasarelyKandinskyMode {...props} />;
    case "vasarelyEames":
      return <VasarelyEamesMode {...props} />;
    case "vasarelyMies":
      return <VasarelyMiesMode {...props} />;
    case "vasarelyFoster":
      return <VasarelyFosterMode {...props} />;
    case "vasarelySolLewitt":
      return <VasarelySolLewittMode {...props} />;
    case "vasarelyMolnar":
      return <VasarelyMolnarMode {...props} />;
    case "vasarelyCaseyReas":
      return <VasarelyCaseyReasMode {...props} />;
    case "vasarelyAnadol":
      return <VasarelyAnadolMode {...props} />;
    case "vasarelyMohr":
      return <VasarelyMohrMode {...props} />;
    case "vasarelyAlbers":
      return <VasarelyAlbersMode {...props} />;
    case "vasarelyRiley":
      return <VasarelyRileyMode {...props} />;
    case "vasarelyEscher":
      return <VasarelyEscherMode {...props} />;
    case "vasarelyTurrell":
      return <VasarelyTurrellMode {...props} />;
    case "vasarelyCalder":
      return <VasarelyCalderMode {...props} />;
    case "vasarelyHowe":
      return <VasarelyHoweMode {...props} />;
    case "vasarelyAgam":
      return <VasarelyAgamMode {...props} />;
    case "vasarelyTuring":
      return <VasarelyTuringMode {...props} />;
    case "vasarelySuzan":
      return <VasarelySuzanMode {...props} />;
    case "vasarelyDaVinci":
      return <VasarelyDaVinciMode {...props} />;
    case "vasarelyMichelangelo":
      return <VasarelyMichelangeloMode {...props} />;
    case "vasarelyRaphael":
      return <VasarelyRaphaelMode {...props} />;
    case "vasarelyVelazquez":
      return <VasarelyVelazquezMode {...props} />;
    case "vasarelyIngres":
      return <VasarelyIngresMode {...props} />;
    case "vasarelyCaravaggio":
      return <VasarelyCaravaggioMode {...props} />;
    case "vasarelyRembrandt":
      return <VasarelyRembrandtMode {...props} />;
    case "vasarelyVermeer":
      return <VasarelyVermeerMode {...props} />;
    case "vasarelyGoya":
      return <VasarelyGoyaMode {...props} />;
    case "vasarelyCourbet":
      return <VasarelyCourbetMode {...props} />;
    case "vasarelyTurner":
      return <VasarelyTurnerMode {...props} />;
    case "vasarelyDelacroix":
      return <VasarelyDelacroixMode {...props} />;
    case "vasarelyMonet":
      return <VasarelyMonetMode {...props} />;
    case "vasarelyVanGogh":
      return <VasarelyVanGoghMode {...props} />;
    case "vasarelyDegas":
      return <VasarelyDegasMode {...props} />;
    case "vasarelyCezanne":
      return <VasarelyCezanneMode {...props} />;
    case "vasarelySeurat":
      return <VasarelySeuratMode {...props} />;
    case "vasarelyMatisse":
      return <VasarelyMatisseMode {...props} />;
    case "vasarelyPicasso":
      return <VasarelyPicassoMode {...props} />;
    case "vasarelyDali":
      return <VasarelyDaliMode {...props} />;
    case "vasarelyHermes":
      return <VasarelyHermesMode {...props} />;
    case "vasarelyChanel":
      return <VasarelyChanelMode {...props} />;
    case "vasarelyDior":
      return <VasarelyDiorMode {...props} />;
    case "vasarelyLouisVuitton":
      return <VasarelyLouisVuittonMode {...props} />;
    case "vasarelyCartier":
      return <VasarelyCartierMode {...props} />;
    case "vasarelyVancleef":
      return <VasarelyVancleefMode {...props} />;
    case "vasarelyRolex":
      return <VasarelyRolexMode {...props} />;
    case "vasarelyPrada":
      return <VasarelyPradaMode {...props} />;
    case "vasarelyGivenchy":
      return <VasarelyGivenchyMode {...props} />;
    case "vasarelyYsl":
      return <VasarelyYslMode {...props} />;
    case "vasarelyBalenciaga":
      return <VasarelyBalenciagaMode {...props} />;
    case "vasarelyMargiela":
      return <VasarelyMargielaMode {...props} />;
    case "vasarelyIssey":
      return <VasarelyIsseyMode {...props} />;
    case "vasarelyTesla":
      return <VasarelyTeslaMode {...props} />;
    case "vasarelyApple":
      return <VasarelyAppleMode {...props} />;
    case "vasarelyTagheuer":
      return <VasarelyTagheuerMode {...props} />;
    case "vasarelyMontblanc":
      return <VasarelyMontblancMode {...props} />;
    case "vasarelyRimowa":
      return <VasarelyRimowaMode {...props} />;
    case "vasarelyRichardmille":
      return <VasarelyRichardmilleMode {...props} />;
    case "vasarelyRollsroyce":
      return <VasarelyRollsroyceMode {...props} />;
    case "vasarelyBo":
      return <VasarelyBoMode {...props} />;
    case "vasarelyLeica":
      return <VasarelyLeicaMode {...props} />;
    case "vasarelyBottega":
      return <VasarelyBottegaMode {...props} />;
    case "vasarelyMoncler":
      return <VasarelyMonclerMode {...props} />;
    case "vasarelySuzanLuxury":
      return <VasarelySuzanLuxuryMode {...props} />;
    case "vasarelyAirbus":
      return <VasarelyAirbusMode {...props} />;
    case "vasarelySafran":
      return <VasarelySafranMode {...props} />;
    case "vasarelyDassaultsystemes":
      return <VasarelyDassaultsystemesMode {...props} />;
    case "vasarelyThales":
      return <VasarelyThalesMode {...props} />;
    case "vasarelyCapgemini":
      return <VasarelyCapgeminiMode {...props} />;
    case "vasarelyAtos":
      return <VasarelyAtosMode {...props} />;
    case "vasarelyOrange":
      return <VasarelyOrangeMode {...props} />;
    case "vasarelyBouygues":
      return <VasarelyBouyguesMode {...props} />;
    case "vasarelyVinci":
      return <VasarelyVinciMode {...props} />;
    case "vasarelyTotalenergies":
      return <VasarelyTotalenergiesMode {...props} />;
    case "vasarelyEngie":
      return <VasarelyEngieMode {...props} />;
    case "vasarelyEdf":
      return <VasarelyEdfMode {...props} />;
    case "vasarelyLvmh":
      return <VasarelyLvmhMode {...props} />;
    case "vasarelyLoreal":
      return <VasarelyLorealMode {...props} />;
    case "vasarelySanofi":
      return <VasarelySanofiMode {...props} />;
    case "vasarelyDanone":
      return <VasarelyDanoneMode {...props} />;
    case "vasarelyVeolia":
      return <VasarelyVeoliaMode {...props} />;
    case "vasarelyBnp":
      return <VasarelyBnpMode {...props} />;
    case "vasarelySocgen":
      return <VasarelySocgenMode {...props} />;
    case "vasarelyAxa":
      return <VasarelyAxaMode {...props} />;
    case "vasarelyCreditagricole":
      return <VasarelyCreditagricoleMode {...props} />;
    case "vasarelyVivendi":
      return <VasarelyVivendiMode {...props} />;
    case "vasarelyPublicis":
      return <VasarelyPublicisMode {...props} />;
    case "vasarelyRenault":
      return <VasarelyRenaultMode {...props} />;
    case "vasarelyStellantis":
      return <VasarelyStellantisMode {...props} />;
    case "vasarelyMichelin":
      return <VasarelyMichelinMode {...props} />;
    case "vasarelyAirliquide":
      return <VasarelyAirliquideMode {...props} />;
    case "vasarelyKering":
      return <VasarelyKeringMode {...props} />;
    // case "vasarelySuzanai":
    //   return <VasarelySuzanaiMode {...props} />;
    case "vasarelyCern":
      return <VasarelyCernMode {...props} />;
    case "vasarelyLion":
      return <VasarelyLionMode {...props} />;
    case "vasarelyTiger":
      return <VasarelyTigerMode {...props} />;
    case "vasarelyElephant":
      return <VasarelyElephantMode {...props} />;
    case "vasarelyZebra":
      return <VasarelyZebraMode {...props} />;
    case "vasarelyLeopard":
      return <VasarelyLeopardMode {...props} />;
    case "vasarelyCheetah":
      return <VasarelyCheetahMode {...props} />;
    case "vasarelyGazelle":
      return <VasarelyGazelleMode {...props} />;
    case "vasarelyRhino":
      return <VasarelyRhinoMode {...props} />;
    case "vasarelyHippo":
      return <VasarelyHippoMode {...props} />;
    case "vasarelyPenguin":
      return <VasarelyPenguinMode {...props} />;
    case "vasarelyOwl":
      return <VasarelyOwlMode {...props} />;
    case "vasarelyEagle":
      return <VasarelyEagleMode {...props} />;
    case "vasarelyFox":
      return <VasarelyFoxMode {...props} />;
    case "vasarelyWolf":
      return <VasarelyWolfMode {...props} />;
    case "vasarelyBear":
      return <VasarelyBearMode {...props} />;
    case "vasarelyKangaroo":
      return <VasarelyKangarooMode {...props} />;
    case "vasarelyKoala":
      return <VasarelyKoalaMode {...props} />;
    case "vasarelyFlamingo":
      return <VasarelyFlamingoMode {...props} />;
    case "vasarelyWhale":
      return <VasarelyWhaleMode {...props} />;
    case "vasarelyDolphin":
      return <VasarelyDolphinMode {...props} />;
    case "vasarelyCapybara":
      return <VasarelyCapybaraMode {...props} />;
    case "vasarelyDwave":
      return <VasarelyDwaveMode {...props} />;
    case "vasarelyNasajpl":
      return <VasarelyNasajplMode {...props} />;
    case "vasarelyGpt5":
      return <VasarelyGpt5Mode {...props} />;
    case "vasarelyDeepmind":
      return <VasarelyDeepmindMode {...props} />;
    case "vasarelyOpenaisafety":
      return <VasarelyOpenaisafetyMode {...props} />;
    case "vasarelyIpcc":
      return <VasarelyIpccMode {...props} />;
    case "vasarelyOceancleanup":
      return <VasarelyOceancleanupMode {...props} />;
    case "vasarelyEsagaia":
      return <VasarelyEsagaiaMode {...props} />;
    case "vasarelyCrispr":
      return <VasarelyCrisprMode {...props} />;
    case "vasarelyHpp":
      return <VasarelyHppMode {...props} />;
    case "vasarelyPasteur":
      return <VasarelyPasteurMode {...props} />;
    case "vasarelyBrianeno":
      return <VasarelyBrianenoMode {...props} />;
    case "vasarelyNeuralink":
      return <VasarelyNeuralinkMode {...props} />;
    case "vasarelyIrcam":
      return <VasarelyIrcamMode {...props} />;
    case "vasarelyUnescoaiethics":
      return <VasarelyUnescoaiethicsMode {...props} />;
    case "vasarelyWorldbank":
      return <VasarelyWorldbankMode {...props} />;
    case "vasarelyBlockchaingovernance":
      return <VasarelyBlockchaingovernanceMode {...props} />;
    case "vasarelyWho":
      return <VasarelyWhoMode {...props} />;
    case "vasarelyUnicef":
      return <VasarelyUnicefMode {...props} />;
    case "vasarelyApc":
      return <VasarelyApcMode {...props} />;
    case "vasarelyKitsune":
      return <VasarelyKitsuneMode {...props} />;
    case "vasarelyAmi":
      return <VasarelyAmiMode {...props} />;
    case "vasarelyJacquemus":
      return <VasarelyJacquemusMode {...props} />;
    case "vasarelySezane":
      return <VasarelySezaneMode {...props} />;
    case "vasarelyLelabo":
      return <VasarelyLelaboMode {...props} />;
    case "vasarelyLemaire":
      return <VasarelyLemaireMode {...props} />;
    case "vasarelyEtudes":
      return <VasarelyEtudesMode {...props} />;
    case "vasarelySandro":
      return <VasarelySandroMode {...props} />;
    case "vasarelyClaudie":
      return <VasarelyClaudieMode {...props} />;
    case "vasarelyBonparfumeur":
      return <VasarelyBonparfumeurMode {...props} />;
    case "vasarelyMerci":
      return <VasarelyMerciMode {...props} />;
    case "vasarelyLouvreposterclub":
      return <VasarelyLouvreposterclubMode {...props} />;
    case "vasarelyBuly":
      return <VasarelyBulyMode {...props} />;
    case "vasarelyPaperclub":
      return <VasarelyPaperclubMode {...props} />;
    case "vasarelyAlainmikli":
      return <VasarelyAlainmikliMode {...props} />;
    case "vasarelyPapiertigre":
      return <VasarelyPapiertigreMode {...props} />;
    case "vasarelyAstier":
      return <VasarelyAstierMode {...props} />;
    case "vasarelyFragonard":
      return <VasarelyFragonardMode {...props} />;
    case "vasarelySuzanaiBobo":
      return <VasarelySuzanaiBoboMode {...props} />;
    case "vasarelyGirafe":
      return <VasarelyGirafeMode {...props} />;
    default:
      return <ConvexMode {...props} />;
  }
}
